<template>

  <v-app id="inspire" theme="dark" dark>
    <v-sheet>
      <v-img min-height="200" max-height="425" style="background-color: #3949ab !important;"
        :src="propertyInfo != undefined ? propertyInfo.bannerUrl : ''"></v-img>
    </v-sheet>

    <v-overlay :value="GetAjaxingRooms()">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-main
      :style="{ 'background-image': 'url(' + (propertyInfo != undefined ? propertyInfo.backgroundUrl : '') + ')', 'background-repeat': 'repeat' }">
      <v-container>


        <v-sheet v-if="GetActiveScreen() !== 'bookingDetail'"
          class="stay-period-box-border no-gutters py-0 mb-1 col-xl-9 col-lg-12 col-sm-12 col-xs-12 col-md-12 mx-auto">
          <v-row>
            <v-col xl="3" lg="3" md="6" sm="6" xs="6" cols="12">
              <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computedDateFormatted" label="Arrival" persistent-hint
                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" no-title @input="startDateMenu = false" show-adjacent-months
                  :min="currentDate" :max="maxDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="6" xs="6" cols="12">
              <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computedEndDateFormatted" label="Departure" persistent-hint
                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" no-title @input="endDateMenu = false" show-adjacent-months
                  :min="minEndDate" :max="maxDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="6" xs="6" cols="6" class="mt-xl-3 mt-lg-3">
              <v-text-field v-model="promoCode" @change="onChangePromoCode" label="PromoCode" solo light dense>
              </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="6" xs="6" cols="6" class="mt-xl-3 mt-lg-3">
              <v-btn @click="searchRoomRatePlan" color="primary">
                Apply
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet class="d-flex no-gutters col-xl-9 col-lg-12 col-sm-12 col-xs-12 col-md-12 mx-auto"
          style="background-color: transparent;">
          <!-- THREE CONTAINER -->
          <v-row v-if="GetActiveScreen() !== 'addRoom'">


            <v-col v-if="GetActiveScreen() === 'room'" cols="12" lg="8" xs="12" sm="12" md="12" class="px-0">
              <template v-show="!GetAjaxingRooms()">
                <!-- for mobile -->
                <a href="#" @click="showModal" id="bookingSummarySticky">
                  <div :class="{ 'sticky-container': true, 'sticky': isSticky }" v-if="modalOpen">
                    <v-col lg="3" xs="12" sm="12" md="12" class="d-block d-sm-none">
                      <v-sheet id="id-booking-info" rounded="lg">
                        <booking-info-sticky></booking-info-sticky>
                      </v-sheet>
                    </v-col>
                  </div>
                </a>
                <v-sheet v-if="GetTimeoutErrorMessage()" min-height="10vh" rounded="lg">
                  <v-container>
                    <v-col class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">
                      Session timeout, Please refresh the page.
                    </v-col>
                  </v-container>
                </v-sheet>
                <v-sheet v-if="GetErrorMessage()" min-height="10vh" rounded="lg">
                  <v-container>
                    <v-col class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">

                      <div class="message-error-container">
                        <div class="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="96px"
                            height="96px">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13l-1.41 1.41L12 13.41l-3.59 3.59L7 15l3.59-3.59L7 7.83 8.41 6.41 12 10l3.59-3.59L17 7.83l-3.59 3.59L17 15z" />
                          </svg>
                        </div>
                        <p v-html="GetErrorMessage()"></p>
                      </div>
                    </v-col>
                  </v-container>
                </v-sheet>
                <v-tabs grow id="roomSelectionTab" class="room-tabs-border" v-model="selectedTab" rounded="lg">
                  <v-tab>Room and Package ({{ rooms.length }})</v-tab>
                  <v-tab v-if="roomPackages.length !== 0">Hot Deal ({{ totalPackages }})</v-tab>
                </v-tabs>


                <!-- Rooms Tab -->
                <v-sheet v-show="selectedTab === 0" min-height="70vh" rounded="lg"
                  style="background-color: transparent !important;">
                  <!-- <v-row no-gutters> -->
                  <v-col class="px-0" v-for="(item, iindex) in rooms" :key="iindex + 'v-col-room-card'">
                    <room-card :room-rate="item" :key="iindex + 'room-card'" :key-index="iindex + 'room-card'"
                      @addRoom="addRoom">
                    </room-card>
                  </v-col>
                  <!-- </v-row> -->

                  <!--  -->
                </v-sheet>
                <!-- Package Tab -->
                <v-sheet v-show="selectedTab === 1" min-height="70vh" rounded="lg"
                  style="background-color: transparent !important;">
                  <!-- <v-row no-gutters> -->
                  <v-col class="px-0" v-for="(item, iindex) in roomPackages" :key="iindex + 'v-col-package-card'">
                    <package-card :room-rate="item" :key="iindex + 'package-card'"
                      :key-index="iindex + 'package-card-parent'" @addRoom="addRoom">
                    </package-card>
                  </v-col>
                  <!-- </v-row> -->

                  <!--  -->
                </v-sheet>
                <v-sheet min-height="30vh" rounded="lg" class="hidden-xs-only">

                  <v-sheet outlined rounded>
                    <property-information></property-information>
                  </v-sheet>
                  <v-sheet outlined rounded class="mt-4">
                    <policy-information></policy-information>
                  </v-sheet>

                </v-sheet>
              </template>
              <template v-if="GetAjaxingRooms()">
                <v-skeleton-loader type="card-avatar, article, actions"></v-skeleton-loader>
              </template>

            </v-col>
            <v-col v-if="GetActiveScreen() === 'bookingDetail'" cols="12" lg="8" xs="12" sm="12" md="12" class="px-0">
              <a href="#" @click="showModal">
                <div :class="{ 'sticky-container': true, 'sticky': isSticky }" v-if="modalOpen">
                  <v-col cols="12" lg="3" xs="12" sm="12" md="12" class="d-block d-sm-none">
                    <v-sheet id="id-booking-info" rounded="lg">
                      <booking-info-sticky></booking-info-sticky>
                    </v-sheet>
                  </v-col>
                </div>
              </a>
              <v-sheet min-height="50vh" rounded outlined>
                <v-col>
                  <payment-detail></payment-detail>
                </v-col>
              </v-sheet>
            </v-col>
            <v-col v-if="GetActiveScreen() === 'confirmation'" class="mx-auto" lg="8" cols="12" xs="12" sm="12" md="12">
              <v-sheet min-height="60vh" rounded="lg">
                <v-col>
                  <booked-details :OrderCode="OrderCode"></booked-details>
                </v-col>
              </v-sheet>
            </v-col>
            <v-col v-if="GetActiveScreen() === 'paymentFailed'" class="mx-auto" lg="6" xs="12" sm="12" md="12">
              <v-sheet min-height="60vh" rounded="lg">
                <v-col>
                  {{ errorDescription }}
                  <PaymentFailed />
                </v-col>
              </v-sheet>
            </v-col>


            <v-col lg="4" xs="12" sm="12" md="12" class="pr-0" v-show="!GetAjaxingRooms()">
              <v-sheet id="id-booking-info" rounded="lg" min-height="268" class="hidden-xs-only">
                <booking-info></booking-info>
              </v-sheet>
            </v-col>
          </v-row>


          <v-row v-if="GetActiveScreen() === 'addRoom'">
            <v-col cols="12" lg="8" xs="12" sm="12" md="12" class="px-0">
              <!-- for mobile -->
              <a href="#" @click="showModalRoom">
                <div :class="{ 'sticky-container': true, 'sticky': isSticky }" v-if="modalOpen">
                  <v-col cols="12" lg="3" xs="12" sm="12" md="12" class="d-block d-sm-none">
                    <v-sheet id="id-booking-info" rounded="lg">
                      <sub-summary-charge-sticky></sub-summary-charge-sticky>
                    </v-sheet>
                  </v-col>
                </div>
              </a>
              <v-sheet min-height="60vh" rounded="lg">
                <v-col class="px-0">
                  <add-room></add-room>
                </v-col>
              </v-sheet>
            </v-col>
            <!-- for web view-->
            <v-col lg="4" xs="12" sm="12" md="12" class="d-none d-sm-block pr-0">
              <v-sheet id="id-summary-charge" v-if="GetRoomReserve() !== null" rounded="lg" min-height="268">
                <sub-summary-charge></sub-summary-charge>
              </v-sheet>
            </v-col>
          </v-row>
        </v-sheet>





      </v-container>

      <!-- modal view booking info -->
      <div class="modal" v-if="isOpen">
        <button class="button-close-modal" @click="closeModal">X</button>
        <booking-info></booking-info>
      </div>

      <div class="modal" v-if="isOpenRoom">
        <button class="button-close-modal" @click="closeModalRoom">X</button>
        <sub-summary-charge></sub-summary-charge>
      </div>

    </v-main>
    <input hidden :value="isLoadedDOM">
    <!-- <footer-component /> -->


  </v-app>

</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

import RoomCard from "../components/RoomRates/RoomCard.vue";
import PackageCard from "../components/RoomRates/PackageCard.vue";
import BookingInfo from "../components/Booking/BookingInfo.vue";
import BookingInfoSticky from "../components/Booking/BookingInfoSticky.vue";
import BookingDetail from "../components/Booking/BookingDetail.vue";
import PaymentDetail from "../components/Booking/PaymentDetail.vue";
import BookedDetails from "../components/Booking/BookedDetails.vue";
import FooterComponent from "./Footer.vue";
import PolicyInformation from "./PolicyInformation.vue";
import PropertyInformation from "./PropertyInformation.vue"
import AddRoom from "../components/Charge/AddRoom.vue";
import SubSummaryCharge from "./Charge/SubSummaryCharge.vue";
import SubSummaryChargeSticky from "./Charge/SubSummaryChargeSticky.vue";
import SearchComponentVue from "./SearchComponent.vue";
import { onMounted, ref } from "vue";

import PaymentFailed from "../components/Booking/PaymentFailed.vue";


export default {
  props: {
    PropertyName: {
      type: String,
      require: true,
    },
    PropertyCode: {
      type: String,
      require: true,
    },
    Type: {
      type: String,
      required: false
    },
    OrderCode: {
      type: String,
      required: false
    }
  },
  components: {
    RoomCard,
    BookingInfo,
    BookingInfoSticky,
    BookingDetail,
    PaymentDetail,
    BookedDetails,
    AddRoom,
    SubSummaryCharge,
    SubSummaryChargeSticky,
    PackageCard,
    SearchComponentVue,
    FooterComponent,
    PolicyInformation,
    PropertyInformation,
    PaymentFailed
  },
  data: () => ({
    links: ["Rooms", "Packages"],
    counter: 3,
    tempCounter: 0,
    selectedTab: 0,
    startDate: "2023-01-01",
    endDate: "2023-01-02",
    endDateMenu: false,
    startDateMenu: false,
    overlay: true,
    timeoutId: null,
    firstLoad: true,
    dates: ["2023-01-01", "2023-01-02"],
    currentDate: "",
    minEndDate: "",
    errorDescription: '',
    promoCode: "",
    isSticky: false,
    isOpen: false,
    isOpenRoom: false,
    modalOpen: true,
    previousPromoCode: "",
    selectedPolicyTab: 0
  }),
  methods: {
    addRoom: function (value, numberOfUnits) {
      let lengSelectedBooking = this.GetBookingInfo().length;

      for (let counter = 1; counter <= numberOfUnits; counter++) {
        this.$store.dispatch("addBookingInfo", {
          ...value,
          bookingNo: lengSelectedBooking + counter,
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    searchRoomRatePlan: function () {

      if (this.previousPromoCode != this.promoCode) {
        this.$store.dispatch('clearRoomReserves');
      }

      // let dates = _.sortBy(this.dates, o => o);

      // Trigger reCAPTCHA verification
      //const recaptchaWidget = this.$refs.recaptcha;
      //const token1 = grecaptcha.getResponse(); // Get reCAPTCHA token

      //console.log("reCAPTCHA token1:", token1);

      // if (!token) {
      //   alert('Please complete the CAPTCHA.');
      //   return;
      // }


      if (!window.grecaptcha) {
        alert("reCAPTCHA not loaded. Please try again.");
        return;
      }
      this.$store.dispatch('setAjaxingRooms', true);

      try {
        grecaptcha.ready(() => {
          grecaptcha.execute("6LfO6eQqAAAAABiBxoqJc5DLshut5AxJHDqkm1pS", { action: "submit" }).then((token) => {
            const model = {
              startDate: this.startDate,
              endDate: this.endDate,
              promoCode: this.promoCode,
              recaptchaToken: token
            };
            this.$store.dispatch("getRoomTypeAvailabilityAndRates", model);
          });
        })

      } catch (error) {
        this.$store.dispatch('clearRoomRates');
        this.$store.dispatch('setAjaxingRooms', false);
        console.error('Login failed:', error);
        alert('Login failed: ' + error);
      } finally {
        // Reset reCAPTCHA
      }


      this.$store.dispatch('setActiveScreen', 'room');

      this.$store.commit('setBookedDetails', null);

      this.previousPromoCode = _.cloneDeep(this.promoCode);

      if (this.$route.name !== 'Booking') {
        let internal = this.isInternal ? 'internal=1' : '';

        this.$router.push(`/Booking/webreservation/${this.PropertyCode}?${internal}`);
      }
      if (this.firstLoad)
        this.firstLoad = false;
    },
    setchange: function () {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.setTimeoutEvent();
      } else {
        this.setTimeoutEvent();
      }

    },
    setTimeoutEvent: function () {
      this.timeoutId = setTimeout(() => {
        this.searchRoomRatePlan();
      }, 1000)
    },
    onChangePromoCode: function () {
      this.promoCode = this.promoCode.trim();
    },
    handleScroll() {
      // Check the scroll position and set the 'isSticky' data accordingly
      this.isSticky = window.scrollY > 0;
    },
    showModal(e) {
      e.preventDefault();

      this.isOpen = true;
      this.modalOpen = false;
    },
    closeModal: function () {
      this.isOpen = false;
      this.modalOpen = true;
    },
    showModalRoom(e) {
      e.preventDefault();

      this.isOpenRoom = true;
      this.modalOpen = false;
    },
    closeModalRoom: function () {
      this.isOpenRoom = false;
      this.modalOpen = true;
    },
  },
  beforeMount: function () {
    this.$store.dispatch("setPropertyCode", this.PropertyCode);

  },
  mounted: function () {



    document.title = 'Booking';
    this.firstLoad = true;
    this.currentDate = moment().format('YYYY-MM-DD');

    this.startDate = moment().format('YYYY-MM-DD');
    this.dates.push(this.startDate);
    let today = new Date();

    today.setDate(today.getDate() + 1);
    this.endDate = moment(today).format('YYYY-MM-DD');
    this.minEndDate = moment(today).format('YYYY-MM-DD');
    this.dates.push(this.endDate);

    grecaptcha.ready(() => {
      console.log("reCAPTCHA client exists and is ready.");
      if (this.$route.name === 'Booking') {
        this.setchange();
      }
    });

    if (this.Type === 'Confirmation') {
      this.$store.dispatch('setActiveScreen', 'confirmation');
    } else if (this.Type === 'PaymentFailed') {
      this.errorDescription = this.$route.query.errorDescription;
      this.$store.dispatch('setActiveScreen', 'paymentFailed');
    }
    this.$store.dispatch("getPropertyInformation", null);


    this.$store.dispatch("getExtraService");
    this.$store.dispatch('fetchCountries');
    window.addEventListener("scroll", this.handleScroll);



  },
  computed: {
    ...mapGetters(["GetRooms",
      "GetBookingInfo",
      "GetActiveScreen",
      "GetAjaxingRooms",
      'GetRoomReserve',
      'GetBookingPolicy',
      'GetPropertyInfo',
      'GetTimeoutErrorMessage',
      'GetErrorMessage']),
    isLoadedDOM: function () {
      if (this.GetAjaxingRooms()) {
        // Check if the element exists and then scroll to it
        //  const targetElement = document.querySelector('#bookingSummarySticky');
        //   if (targetElement) {
        //       targetElement.scrollIntoView({ behavior: 'smooth' });
        //   }
      }

      return this.GetAjaxingRooms();
    },
    rooms: function () {
      // return _.sortBy(this.GetRooms().filter((r) => {
      //   return (
      //     !r.isPackage
      //   );
      // }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } }), o => o.totalPrice);

      return this.GetRooms().filter((r) => {
        return (
          !r.isPackage
        );
      }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } });
    },
    roomPackages: function () {
      let listPackage = [];
      let list = _.sortBy(this.GetRooms().filter((r) => {
        return (
          r.isPackage
        );
      }).map((item) => { return { ...item, totalPrice: item.roomRatePlans[0].totalPrice } }), o => o.totalPrice);

      let listIds = [];
      list.map(x => {
        x.roomRatePlans.map(r => {
          listIds.push(r.hotDealId);
        })
      })


      listIds = [...new Set(listIds)];

      for (let count = 0; count < listIds.length; count++) {
        let id = listIds[count];
        let rates = [];
        let hotDealName = '';
        let hotDealDescription = '';
        let roomImages = [];
        list.map(m => {


          m.roomRatePlans.map(r => {
            if (r.hotDealId === id) {
              hotDealName = r.hotDealName;
              hotDealDescription = r.hotDealDescription;
              rates.push({ ...r, room: { ...m, roomRatePlans: null } });
              roomImages = r.roomImages;
            }
          })
        })
        let listSorted = _.sortBy(rates, o => o.totalPrice);
        listPackage.push({ roomRatePlans: listSorted, hotDealDescription, hotDealName, roomImages, totalPrice: listSorted[0].totalPrice })

      }


      return listPackage;

    },
    computedDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate);
    },
    totalPackages: function () {
      if (this.roomPackages === null || this.roomPackages === undefined)
        return 0;


      return this.roomPackages.length;

    },
    propertyInfo: function () {
      return this.GetPropertyInfo();
    },
    isInternal: function () {
      let internal = this.$route.query.internal;

      if (internal === undefined)
        return false;

      if (internal === '1' || internal === 1)
        return true;

      return false;

    },
    maxDate: function () {
      let today = new Date();

      today.setFullYear(today.getFullYear() + 1);
      const maxDate = moment(today).format('YYYY-MM-DD');

      return maxDate;
    }
  },
  watch: {
    Type: function () {
      if (this.Type === 'Confirmation') {
        this.$store.dispatch('setActiveScreen', 'confirmation');
      }
      else if (this.Type === 'PaymentFailed') {
        this.errorDescription = this.$route.query.errorDescription;
        this.$store.dispatch('setActiveScreen', 'paymentFailed');
      }
    },
    dates: function () {
      if (this.dates.length === 2) {
        if (this.$route.name === 'Booking') {
          // this.searchRoomRatePlan();
        }
      }

    },
    startDate: function () {
      if (this.$route.name === 'Booking') {
        if (moment(this.startDate) >= moment(this.endDate)) {
          let endDateTemp = new Date(this.startDate);
          endDateTemp.setDate(endDateTemp.getDate() + 1);
          this.endDate = moment(endDateTemp).format('YYYY-MM-DD');
        }
        // else if(moment(this.startDate).format('YYYY-MM-DD') === moment(this.endDate).format('YYYY-MM-DD')){
        //   let startDateTemp = new Date(this.endDate);
        //   startDateTemp.setDate(startDateTemp.getDate() + 1);
        //   this.startDate = moment(startDateTemp).format('YYYY-MM-DD');
        // }

        // this.searchRoomRatePlan();
        this.setchange();
      }
    },
    endDate: function () {
      if (this.$route.name === 'Booking') {
        if (moment(this.startDate) >= moment(this.endDate)) {
          let startDateTemp = new Date(this.endDate);
          startDateTemp.setDate(startDateTemp.getDate() - 1);
          this.startDate = moment(startDateTemp).format('YYYY-MM-DD');
        }
        // else if(moment(this.startDate).format('YYYY-MM-DD') === moment(this.endDate).format('YYYY-MM-DD')){
        //   let startDateTemp = new Date(this.endDate);
        //   startDateTemp.setDate(startDateTemp.getDate() + 1);
        //   this.startDate = moment(startDateTemp).format('YYYY-MM-DD');
        // }

        // this.searchRoomRatePlan();
        this.setchange();
      }
    },
    propertyInfo: function () {
      if (this.propertyInfo) {
        document.title = `Booking - ${this.propertyInfo.name}`;
        document.body.style.backgroundImage = `url(${this.propertyInfo.backgroundUrl})`;
      }

    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


<style>
/* div#id-booking-info.v-sheet.theme--light.rounded-lg,
div#id-summary-charge.v-sheet.theme--light.rounded-lg {
  position: sticky !important;
  top: 130px !important
} */

.content {
  padding: 16px;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

.sticky+.content {
  padding-top: 60px;
}

.sticky-container {
  z-index: 2;
}

.sticky-container.sticky {
  position: sticky;
  top: -12px;
  /* Add any additional styles for the sticky behavior */
}

.modal {
  position: fixed;
  /* top: 25%; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.2);
}

.button-close-modal {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  margin-left: auto;
  background-color: #607d8b;
  position: fixed;
  /* top: 25%; */
  z-index: 100;
  left: 90%;
}

.stay-period-box-border {
  padding: 16px !important;
  border-radius: 4px !important;
  border: 2px solid #607d8b !important;
}

.room-tabs-border {
  border-radius: 4px !important;
  border: thin solid rgba(0, 0, 0, .12) !important;
}

/* #1565c0 */

.theme--light.v-sheet {
  color: #164574 !important;
}

.message-error-container {
  text-align: center;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.icon {
  margin-bottom: 20px;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

p {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}
</style>